import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MobileConfigService } from '../services/mobile/mobile-config.service';
import { catchError, throwError } from 'rxjs';

export const mobileInterceptor: HttpInterceptorFn = (req, next) => {
  const mobileConfig = inject(MobileConfigService);

  // Non intercettare le richieste di traduzione (assets)
  if (req.url.includes('/assets/') || req.url.includes('./assets/')) {
    return next(req);
  }

  // Se siamo su mobile e l'URL è relativo, lo convertiamo in assoluto
  if (mobileConfig.isMobile() && req.url.startsWith('/')) {
    let absoluteUrl = req.url;

    // Mappa gli URL relativi a quelli assoluti
    if (req.url.startsWith('/auth-service')) {
      // Sostituisce completamente il prefisso con l'URL base mobile
      absoluteUrl = mobileConfig.getApiBaseUrl() + req.url.substring('/auth-service'.length);
    } else if (req.url.startsWith('/user-service')) {
      absoluteUrl = mobileConfig.getUserBaseUrl() + req.url.substring('/user-service'.length);
    } else if (req.url.startsWith('/equipment-service')) {
      absoluteUrl = mobileConfig.getEquipmentBaseUrl() + req.url.substring('/equipment-service'.length);
    } else {
      // Per URL relativi generici, usa l'API base
      absoluteUrl = mobileConfig.getApiBaseUrl() + req.url;
    }

    // Crea una nuova richiesta con l'URL assoluto
    // Preserva gli header esistenti ma assicurati che siano compatibili con CORS
    const headers: { [key: string]: string } = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    // Copia gli header esistenti dalla richiesta originale
    req.headers.keys().forEach(key => {
      const value = req.headers.get(key);
      if (value) {
        headers[key] = value;
      }
    });

    const modifiedReq = req.clone({
      url: absoluteUrl,
      setHeaders: headers
    });

    return next(modifiedReq).pipe(
      catchError(error => {
        // Gestione errori specifici per mobile
        if (!mobileConfig.getNetworkStatus()) {
        }

        // Gestione errori Mixed Content
        if (error.message && error.message.includes('Mixed Content')) {
        }

        return throwError(() => error);
      })
    );
  }

  // Per le richieste web normali, procedi senza modifiche
  return next(req);
};